import dynamic from 'next/dynamic';
import Hero from '@/components/about-us/Hero';
import HeadQuarters from '@/components/about-us/HeadQuarters';
import KeyMetrics from '@/components/about-us/KeyMetrics';
import Marketplace from '@/components/about-us/Marketplace';
import Definition from '@/components/about-us/Definition';
import Team from '@/components/about-us/Team';
import Trust from '@/components/about-us/Trust';
import Vision from '@/components/about-us/Vision';
import FeaturedClient from '@/components/homepage/FeaturedClient';
import { getShortenCountryName } from '@/lib/use-origin-country';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import i18n from '@/settings/i18n';

const t = i18n.init('about');

const RecentReviews = dynamic(
  () => import('@/components/homepage/RecentReviews'),
  {
    ssr: false,
    // Same space RecentReviews holds while the reviews load
    loading: () => <div className="min-h-[250px]" />,
  },
);

const AboutUs = () => (
  <>
    <WebsiteSchema
      title={t`About Us - Reebelo ${{ country: getShortenCountryName() }}`}
      description={t`Our mission is to refresh the way we all consume tech. We believe in a future where everyone has access to affordable electronics. Delivered through a platform built on sustainable values and quality-assured devices. Whether it's refurbished or new, buying or selling, it's time to say hello to Reebelo - APAC's fastest`}
    />
    <div className="text-sm leading-snug text-gray-700 md:text-base">
      <Hero />
      <Vision />
      <Trust />
      <Marketplace />
      <Definition />
      <KeyMetrics />
      <Team />
      <HeadQuarters />
      <section className="mx-auto p-5 py-20 lg:container">
        <RecentReviews />
      </section>
      <div className="bg-white py-8 xxs:py-10 md:py-12 lg:py-14">
        <div className="reebelo-container">
          <FeaturedClient />
        </div>
      </div>
    </div>
  </>
);

export default AboutUs;
